import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgTripMap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.694 4.81v12.727m7.24.118v3.14"
      stroke="#17181A"
      strokeDasharray={1}
    />
    <path
      clipRule="evenodd"
      d="M15.934 8.792a2.896 2.896 0 1 0 0-5.792 2.896 2.896 0 0 0 0 5.792Z"
      stroke="#17181A"
    />
    <path
      d="M15.934 8.792v6.98m2.89-9.807 3.25-1.446v14.232l-6.265 2.632-7.002-3.264-6.11 2.212V6.089l5.953-1.8 4.37 1.714"
      stroke="#17181A"
    />
    <path d="M15.934 3.724s1.523.12 1.926 1.261" stroke="#17181A" />
  </svg>
);
const Memo = memo(SvgTripMap);
export default Memo;
